import { Alert, ButtonBase, Grid, Snackbar, Typography } from '@mui/material';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import useLoginFooterStyles from './loginfooter.style';
import packageJSON from '../../package.json';
import { EngagementEvents, logKariusEvent } from '../Analytics';
import KariusLogoFooter from '../assets/images/svg/KariusLogoFooter';
import { getClientConfig } from '../Config/ClientConfig';
import { contactSupport } from '../Header/HeaderUtils';

export default function LoginFooter() {
  const styles = useLoginFooterStyles();
  const [packageVersion, setPackageVersion] = useState('');

  useEffect(() => {
    (async () => {
      const { showPackageVersion } = await getClientConfig();
      if (showPackageVersion) {
        setPackageVersion(packageJSON.version);
      }
    })();
  }, []);

  return (
    <Grid
      css={styles.loginFooterContainer}
      container
      direction='column'
      alignItems='flex-start'
      id='login-footer-container'
    >
      <Grid item>
        <Grid item container direction='column' css={styles.logoContainer}>
          <KariusLogoFooter data-test='karius-footer-logo' />
          <Grid data-test='footer-clia' item>
            CLIA #05D2121236
          </Grid>
          <Grid data-test='footer-cap' item>
            CAP #9497749
          </Grid>
        </Grid>
      </Grid>
      <FooterLink title='Home' href='https://kariusdx.com/' event='home' />
      <FooterLink title='Privacy Policy' href='https://kariusdx.com/privacy-policy/' event='privacy' />
      <FooterLink title='Licensure' href='https://kariusdx.com/licensure/' event='licensure' />
      <FooterLink
        title='Lab & Physician Instructions'
        href='https://karius.showpad.com/share/eMdS8q9YeDVU1NyoHG4aS'
        event='lab_phy_instructions'
      />
      <Grid item data-test='footer-contact'>
        Contact
        <Grid container direction='column'>
          <ContactOption title='Phone: (866) 452-7487' link='phone' />
          <ContactOption title='Fax: (866) 246-6567' link='fax' />
          <ContactOption title='help@kariusdx.com' link='email' />
        </Grid>
        {packageVersion && (
          <Typography
            data-test='footer-package-version'
            css={{
              flexGrow: 1,
              display: 'flex',
              justifyContent: 'end',
              alignItems: 'flex-end',
              color: 'white',
              fontSize: 13,
              marginTop: 100,
            }}
          >
            Package Version: {packageVersion}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}

const ContactOption = ({ title, link }: { title: string; link: 'phone' | 'fax' | 'email' }) => {
  const [showAlert, setShowAlert] = useState(false);
  return (
    <Grid data-test={link} item>
      <ButtonBase
        css={{ userSelect: 'text' }}
        onClick={() => {
          logKariusEvent(EngagementEvents.footer_link_tapped, { link });
          contactSupport(link);
          if (link === 'fax') setShowAlert(true);
        }}
      >
        {title}
      </ButtonBase>
      <Snackbar open={showAlert} onClose={() => setShowAlert(false)} autoHideDuration={3000}>
        <Alert severity='info' onClose={() => setShowAlert(false)}>
          Text copied to clipboard
        </Alert>
      </Snackbar>
    </Grid>
  );
};

interface FooterLinkInterface {
  title: string;
  href: string;
  event: 'home' | 'privacy' | 'licensure' | 'lab_phy_instructions';
}

const FooterLink = ({ title, href, event }: FooterLinkInterface) => {
  const styles = useLoginFooterStyles();

  return (
    <Grid css={styles.footerLinks} item>
      <Link data-test={event} href={href} passHref={true}>
        <ButtonBase onClick={() => logKariusEvent(EngagementEvents.footer_link_tapped, { link: event })}>
          {title}
        </ButtonBase>
      </Link>
    </Grid>
  );
};
